import { render } from "./MeasureStdDetail.vue?vue&type=template&id=fc20ef3a&scoped=true"
import script from "./MeasureStdDetail.vue?vue&type=script&lang=js"
export * from "./MeasureStdDetail.vue?vue&type=script&lang=js"

import "./MeasureStdDetail.vue?vue&type=style&index=0&id=fc20ef3a&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc20ef3a"]])

export default __exports__